import {
  GroupByMode,
  ID,
  ReorderSectionUpdate,
  SmartList,
  SortingMode,
  UpdateSmartList,
} from '@griply/types';

export type BuildSmartListReorderUpdateOptions = {
  smartList: SmartList;
  updatedSections: ReorderSectionUpdate[];
  groupByMode: GroupByMode;
};

export const buildSmartListReorderUpdate = ({
  smartList,
  updatedSections,
  groupByMode,
}: BuildSmartListReorderUpdateOptions): UpdateSmartList | null => {
  const patchedFilterDocument = {
    ...smartList.filterDocument,
    sortingMode: SortingMode.Custom,
  };

  if (groupByMode === GroupByMode.None) {
    const taskSorting = updatedSections[0]?.taskSorting;
    if (!taskSorting) {
      return null;
    }
    return {
      id: smartList.id,
      taskSorting,
      filterDocument: patchedFilterDocument,
    };
  }

  if (!updatedSections.length) {
    return null;
  }

  const groupBySorting = updatedSections.reduce<Record<ID, ID[]>>(
    (acc, section) => {
      acc[section.id] = section.taskSorting;
      return acc;
    },
    {},
  );

  return {
    id: smartList.id,
    customTaskOrder: {
      ...(smartList.customTaskOrder ?? {}),
      [groupByMode]: groupBySorting,
    },
    filterDocument: patchedFilterDocument,
  };
};
